import {
  GET_DISCONNECT_HOLDS,
  GET_DISCONNECT_HOLDS_RESPONSE,
  GET_DISCONNECT_HOLDS_FAIL,
  POST_DISCONNECT_HOLD,
  POST_DISCONNECT_HOLD_RESPONSE,
  POST_DISCONNECT_HOLD_FAIL,
  PUT_DISCONNECT_HOLD,
  PUT_DISCONNECT_HOLD_RESPONSE,
  PUT_DISCONNECT_HOLD_FAIL,
  DELETE_DISCONNECT_HOLD,
  DELETE_DISCONNECT_HOLD_RESPONSE,
  DELETE_DISCONNECT_HOLD_FAIL,
  LIFT_DISCONNECT_HOLD,
  LIFT_DISCONNECT_HOLD_RESPONSE,
  LIFT_DISCONNECT_HOLD_FAIL,
  RESET,
} from "./actions";

const initialState = {
  isLoading: false,
  error: null,
  data: {
    disconnectHoldsList: {
      items: [],
      total: 0,
      page: 1,
      limit: 10,
      totalRows: 0,
    },
  },
  disconnectHoldsTotalRows: 0,
  newDisconnectHold: {
    holdType: 'GROUP',
    groupId: null,
    propertyId: null,
    reason: '',
    notes: '',
    expiresAt: null,
    isActive: true,
    liftReason: '',
  },
  searchQuery: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return Object.assign({}, initialState);

    case GET_DISCONNECT_HOLDS:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case GET_DISCONNECT_HOLDS_RESPONSE:
      // Backend returns { total, data }
      const newItems = Array.isArray(action.disconnectHolds) ? action.disconnectHolds : [];
      const newStateData = state.data;
      newStateData.disconnectHoldsList.items = newItems;
      newStateData.disconnectHoldsList.total = action.total || 0;
      newStateData.disconnectHoldsList.page = action.page || 1;
      newStateData.disconnectHoldsList.limit = action.limit || 10;
      const totalRows = action.total || newItems.length;

      return {
        ...state,
        data: newStateData,
        disconnectHoldsTotalRows: totalRows,
        error: action.error,
        isLoading: false,
      };

    case GET_DISCONNECT_HOLDS_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case POST_DISCONNECT_HOLD:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case POST_DISCONNECT_HOLD_RESPONSE:
      return {
        ...state,
        postDisconnectHoldError: null,
        isLoading: false,
      };

    case POST_DISCONNECT_HOLD_FAIL:
      return {
        ...state,
        postDisconnectHoldError: action.error,
        isLoading: false,
      };

    case PUT_DISCONNECT_HOLD:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case PUT_DISCONNECT_HOLD_RESPONSE:
      return {
        ...state,
        putDisconnectHoldError: null,
        isLoading: false,
      };

    case PUT_DISCONNECT_HOLD_FAIL:
      return {
        ...state,
        putDisconnectHoldError: action.error,
        isLoading: false,
      };

    case DELETE_DISCONNECT_HOLD:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case DELETE_DISCONNECT_HOLD_RESPONSE:
      return {
        ...state,
        deleteDisconnectHoldError: null,
        isLoading: false,
      };

    case DELETE_DISCONNECT_HOLD_FAIL:
      return {
        ...state,
        deleteDisconnectHoldError: action.error,
        isLoading: false,
      };

    case LIFT_DISCONNECT_HOLD:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };

    case LIFT_DISCONNECT_HOLD_RESPONSE:
      return {
        ...state,
        liftDisconnectHoldError: null,
        isLoading: false,
      };

    case LIFT_DISCONNECT_HOLD_FAIL:
      return {
        ...state,
        liftDisconnectHoldError: action.error,
        isLoading: false,
      };

    default:
      return state;
  }
};
